class Func {
    constructor () {
    }
    // 获取当前时间
    getDate () {
        var nowDate = new Date();
        let date = {
            year: nowDate.getFullYear(),
            month: nowDate.getMonth() + 1,
            date: nowDate.getDate(),
        }
        return date.year;
    }
}
export default new Func()


// WEBPACK FOOTER //
// ./src/assets/js/fun.js